import { createContext } from "react"

export const BookmarksContext = createContext()
